import React, { createContext, useContext, useMemo, useState } from "react";

interface UsabillaContextProps {
  usabillaVisibility: "show" | "hide";
  setUsabillaVisibility: React.Dispatch<React.SetStateAction<"show" | "hide">>;
}

const UsabillaContext = createContext<UsabillaContextProps | undefined>(undefined);

export const UsabillaProvider = ({ children }: any) => {
  const [usabillaVisibility, setUsabillaVisibility] = useState<"show" | "hide">("show");

  const value = useMemo(
    () => ({
      usabillaVisibility,
      setUsabillaVisibility,
    }),
    [usabillaVisibility, setUsabillaVisibility],
  );

  return <UsabillaContext.Provider value={value}>{children}</UsabillaContext.Provider>;
};

export const useUsabilla = () => {
  const context = useContext(UsabillaContext);

  if (context === undefined) {
    throw new Error("useUsabilla context must be used within a UsabillaProvider");
  }

  return context;
};
